module.exports = __webpack_public_path__ + "img/d5f9bc6.jpg";